<template>
  <div>
    <!-- <SpaNav selectIndex="4"/> -->
    <PCNavbar selectIndex="6"/>
    <Device/>
    <CallMe/>
    <!-- <MobileNavBar :currentActive="4" /> -->
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import SpaNav from '@/components/report_list/SpaNav.vue'
import Device from '@/components/assistive_device/index.vue'
import CallMe from '@/components/callme/index'

export default {
  components: {
    PCNavbar,
    MobileNavBar,
    SpaNav,
    Device,
    CallMe
  },
}
</script>

<style>
</style>